module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-five1.8c249d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-five1.png
// module id = nfiZ
// module chunks = 0